export default "__VITE_ASSET__50a34a44__"